import * as React from 'react';

type TriggerRef = React.RefObject<HTMLButtonElement | HTMLInputElement | null>;

type PopupContext = {
  triggerRef: TriggerRef;
  triggerClickedRef: React.RefObject<boolean>;
  popupId?: string;
  isOpen?: boolean;
  setOpen: (open: boolean) => void;
  closePopup: () => void;
};

const PopupContext = React.createContext<PopupContext>({} as PopupContext);

export const usePopup = () => {
  const context = React.useContext(PopupContext);
  if (context === undefined) {
    throw new Error('usePopup must be used within a Popup Component parent');
  }
  return context;
};

export { PopupContext };
export default PopupContext;
